import React, { useEffect, useContext } from 'react';
import { PROJECTNAME, } from '../../types/searchTypes';
import { getSearchResults, getFilesForDatasets, filterFiles, } from '../../utils/getFacetsInfo';
import { DatasetSelectionCtx, FileSelectionCtx, } from '../App/ApplicationContext';
import { COMPLETE } from '../../types/dataTypes';
const GetFilesForQuery = ({ searchQuery, project, nodes, queryLimit, operation, children, }) => {
    const { datasetCollection } = useContext(DatasetSelectionCtx);
    const { fileCollection } = useContext(FileSelectionCtx);
    const [fileListObject, setFileListObject] = React.useState([]);
    const [completed, setCompleted] = React.useState(0);
    const variables = searchQuery.selectedItems
        .filter((item) => item.facetId === 'variable')
        .map((item) => item.fieldId);
    useEffect(() => {
        getSearchResults(searchQuery, project, nodes, queryLimit)
            .then((result) => {
            // Filtered and reduced to ids of selected datasets
            const datasetIds = result.results.reduce((idCollection, res) => {
                datasetCollection.some((ctxItem) => res.id === ctxItem.id && idCollection.push(res.id));
                return idCollection;
            }, []);
            getFilesForDatasets(datasetIds, operation, nodes, (per) => {
                setCompleted(parseInt(`${per}`, 10));
            })
                .then((res) => {
                setCompleted(COMPLETE);
                setFileListObject([
                    ...res.map((r) => ({
                        datasetId: r.datasetId,
                        fileList: project.title === PROJECTNAME.CMIP5
                            ? filterFiles(r.fileList, variables)
                            : r.fileList,
                    })),
                    {
                        // All files hand picked from a dataset go here:
                        datasetId: '',
                        variable: '',
                        fileList: fileCollection,
                    },
                ]);
            })
                .catch((err) => console.error(err));
        })
            .catch((err) => console.error(err));
    }, [
        searchQuery,
        project.facetName,
        nodes,
        queryLimit,
        datasetCollection.length,
        fileCollection.length,
    ]);
    return React.createElement(React.Fragment, null, children(fileListObject, completed, queryLimit));
};
export default GetFilesForQuery;
